import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

import AddCircleIcon from "@material-ui/icons/AddCircle";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";

class ManageFeeBody extends Component {
  render() {
    const { classes, data, index } = this.props;
    return (
      <TableRow>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">
          {data.firstName} {data.middleName} {data.lastName}
        </TableCell>
        <TableCell align="center">{data.studentClass}</TableCell>
        <TableCell align="center">
          {data.faculty ? data.faculty : "N/A"}
        </TableCell>
        <TableCell align="center">{data.group ? data.group : "N/A"}</TableCell>
        <TableCell align="center">{data.section}</TableCell>
        <TableCell align="center">
          <Tooltip
            arrow
            title="Add Fee"
            className={classes.tooltip}
            onClick={() => this.props.handleShowDetails(data)}
          >
            <AddCircleIcon />
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  }
}

export default withStyles(useStyles)(ManageFeeBody);
